/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Icon, Message, MessageContent } from 'semantic-ui-react'
import { Title } from './Title'
import { Text } from './Text'
import { List } from './List'
import { ListItem } from './ListItem'
import { useFeatureInfoVisibility } from '../../Home/Margin/hooks/useFeatureInfoVisibility'

const FeatureInfo = ({ featureName, children, isVisible: isVisibleProp, onDismiss, onOpen, ...props }) => {
    const [isVisibleInternal, setAndPersistIsVisible] = useFeatureInfoVisibility({key: featureName})

    const isVisible = isVisibleProp !== undefined ? isVisibleProp : isVisibleInternal
    const handleOnDismiss = onDismiss !== undefined ? onDismiss : () => setAndPersistIsVisible(false)
    const handleOnOpen = onOpen !== undefined ? onOpen : () => setAndPersistIsVisible(true)

    if (!isVisible) {
        return (
          <Icon
            name="info circle"
            color="blue"
            className={props.className}
            onClick={handleOnOpen}
            css={css`
                cursor: pointer;
            `}
          />
        )
    }

    return (
      <Message
        color="blue"
        icon
        onDismiss={handleOnDismiss}
        className={props.className}
      >
          <Icon name="info circle" />
          <MessageContent>
              {children}
          </MessageContent>
      </Message>
    )
}

FeatureInfo.Title = Title
FeatureInfo.Text = Text
FeatureInfo.List = List
FeatureInfo.ListItem = ListItem

export { FeatureInfo }
